/*!
Waypoints Focus Shortcut - 1.0.0
Copyright © 2017 Panorama Studios
Licensed under the MIT license.
*/
(function () {
    'use strict'

    function noop() { };

    var Waypoint = window.Waypoint;

    /* http://imakewebthings.com/waypoints/shortcuts/Focus */
    function Focus(options) {
        this.options = Waypoint.Adapter.extend({}, Focus.defaults, options);
        this.axis = this.options.horizontal ? 'horizontal' : 'vertical';
        this.waypoints = [];
        this.element = this.options.element;
        this.createWaypoints();
    }

    /* Private */
    Focus.prototype.createWaypoints = function () {
        var configs = {
            vertical: [
                {
                    handler: 'down',
                    offset: function (offset) {
                        //console.log('down', offset, this.adapter);
                        return offset;
                    }
                },
                {
                    handler: 'up',
                    offset: function (offset) {
                        return -this.element.clientHeight + offset;
                    }
                }
            ],
            horizontal: [
                {
                    handler: 'left',
                    offset: function (offset) {
                        return offset;
                    }
                },
                {
                    handler: 'right',
                    offset: function (offset) {
                        return -this.element.clientWidth + offset;
                    }
                }
            ]
        };

        for (var i = 0, end = configs[this.axis].length; i < end; i++) {
            var config = configs[this.axis][i];
            this.createWaypoint(config);
        }
    }

    /* Private */
    Focus.prototype.createWaypoint = function (config) {
        var self = this;
        this.waypoints.push(new Waypoint({
            context: this.options.context,
            element: this.options.element,
            enabled: this.options.enabled,
            handler: (function (config) {
                return function (direction) {
                    if (config.handler === direction) self.options.handler.call(self, direction);
                }
            }(config)),
            offset: function () {
                return config.offset.call(this, self.options.offset);
            },
            horizontal: this.options.horizontal
        }));
    };

    /* Public */
    Focus.prototype.destroy = function () {
        for (var i = 0, end = this.waypoints.length; i < end; i++) {
            this.waypoints[i].destroy()
        }
        this.waypoints = []
    }

    Focus.prototype.disable = function () {
        for (var i = 0, end = this.waypoints.length; i < end; i++) {
            this.waypoints[i].disable()
        }
    }

    Focus.prototype.enable = function () {
        for (var i = 0, end = this.waypoints.length; i < end; i++) {
            this.waypoints[i].enable()
        }
    }

    Focus.defaults = {
        context: window,
        enabled: true,
        handler: noop,
        offset: 0
    }

    Waypoint.Focus = Focus
}());